/* ══════════════════════════════════════════════════════════════════
   评测墙的片单 —— 只做一件事：换显示哪一格

   **它不请求任何东西。** 每条片的封面、角标、结论、车名在页面里本来就
   都在，只是带着 `hidden`。点一行＝把 hidden 挪到别处。所以：
     · 没有 JS 也能看第一条（第一格本来就是显示的）；
     · 换片不会闪，不会重新排版，也不会多一次网络往返；
     · 真正的 iframe 仍然只在按播放键时才插进来（component-video.js）。

   **播过的那一格不回退。** 换走再换回来，iframe 还在，进度也还在 ——
   把它清掉等于替观众决定他不想接着看。

   事件委托挂在 document 上：运营在编辑器里现加一节，它照样活。
   ══════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  document.addEventListener('click', function (e) {
    var row = e.target.closest('[data-rv-row]');
    if (!row) return;

    var rv = row.closest('[data-rv]');
    if (!rv) return;

    var i = row.dataset.rvRow;

    rv.querySelectorAll('[data-rv-row]').forEach(function (r) {
      r.setAttribute('aria-current', r === row ? 'true' : 'false');
    });
    rv.querySelectorAll('[data-rv-slot]').forEach(function (slot) {
      slot.hidden = slot.dataset.rvSlot !== i;
    });
    rv.querySelectorAll('[data-rv-meta]').forEach(function (meta) {
      meta.hidden = meta.dataset.rvMeta !== i;
    });
  });
})();
